(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .constant('paginationConstants', {
            'itemsPerPage': 5
        });
})();
